import { Interaction } from './interaction';
import { VectorLayer } from '../vector_layer';

import ModifyInteraction from 'ol/interaction/Modify';
import Collection from 'ol/Collection';

import { shiftKeyOnly, singleClick } from 'ol/events/condition';

const modify = (layer, feature, style) => {
	let source = null;
	let features = null;
	
	if( layer instanceof VectorLayer ) {
		source = layer.source;	   	
   	} else if( feature ) {
   		features = new Collection([feature]);
   		features.push(feature);
   	}

	const control = new ModifyInteraction({
    	style: style,
   	 	source: source,
    	features: features,
    	deleteCondition: (event) => {
        	return shiftKeyOnly(event) && singleClick(event);
    	}
	});	
   	
	return new Interaction( control );	
}

export {
	modify 
}
